<h2>Meta Particles</h2>
<p>Below is a list of all Meta Particles.</p>
@if (metaParticles()) {
  <angular2-smart-table [settings]="settings" [source]="source" />
} @else {
  <app-loader />
}